import React from 'react';
import LatexRenderer from './LatexRenderer';
import { Plot2D, Plot3D, VectorField } from '../Plotting';
import { useAppContext } from '../../context/AppContext';
import ErrorBoundary from '../Common/ErrorBoundary';

console.log('🚀 OutputRenderer module loaded');

const OutputRenderer = () => {
  const { latexOutput, isProcessing } = useAppContext();
  
  console.log('🔍 OutputRenderer mounted - latexOutput:', latexOutput);
  console.log('🔍 OutputRenderer mounted - isProcessing:', isProcessing);

  if (isProcessing) {
    console.log('🔍 OutputRenderer: Still processing...');
    return <div className="status processing">🔄 Processing expressions...</div>;
  }

  if (!latexOutput || latexOutput.length === 0) {
    console.log('🔍 OutputRenderer: No output data');
    return <div className="status">Type a formula to see results...</div>;
  }

  return (
    <ErrorBoundary fallback={<div className="status error">Error rendering output</div>}>
      <div className="output-container">
        {latexOutput.map((item, index) => {
          if (item.error) {
            return (
              <div key={index} className="output-block error-block">
                <div className="error-line">❌ {item.error}</div>
              </div>
            );
          }

          // Check if this is plot data
          if (item.plotData) {
            console.log('🎯 OutputRenderer - Processing item:', item);
            console.log('📈 Rendering Plot3D with data:', item.plotData);
            return renderPlotComponent(item.plotData, index);
          }

          // Check if the item itself is plot data (direct plot response)
          if (item.type && (item.type === 'plot2d' || item.type === 'plot3d' || item.type === 'vectorfield')) {
            console.log('🎯 OutputRenderer - Direct plot data detected:', item);
            console.log('📈 Rendering direct plot with data:', item);
            return renderPlotComponent(item, index);
          }

          // Default to LaTeX rendering
          return (
            <div key={index} className="output-block latex-block">
              <div className="latex-content">
                {item.latex || 'No LaTeX content'}
              </div>
            </div>
          );
        })}
      </div>
    </ErrorBoundary>
  );
};

const renderPlotComponent = (plotData, key) => {
  console.log('🎯 renderPlotComponent called with:', plotData);
  console.log('🎯 plotData.type:', plotData.type);
  console.log('🎯 plotData.data:', plotData.data);
  
  if (!plotData || !plotData.type || !plotData.data) {
    console.log('❌ Invalid plot data structure');
    return (
      <div className="error-line">
        Invalid plot data structure
      </div>
    );
  }

  const { type, data, metadata } = plotData;
  console.log('🎯 About to render plot type:', type);

  switch (type) {
    case 'plot2d':
      console.log('📊 Rendering Plot2D');
      return <Plot2D key={key} data={data} metadata={metadata} />;
    case 'plot3d':
      console.log('📈 Rendering Plot3D with data:', data);
      return <Plot3D key={key} data={data} metadata={metadata} />;
    case 'vectorfield':
      console.log('🔄 Rendering VectorField');
      return <VectorField key={key} data={data} metadata={metadata} />;
    default:
      console.log('❌ Unknown plot type:', type);
      return (
        <div className="error-line">
          Unknown plot type: {type}
        </div>
      );
  }
};

export default OutputRenderer;